import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, Box, Copy, Icon, themeColor } from '@elparking/components'

import Distance from 'commons/js/ui/Distance'

export const Container = styled(Flex)`
    box-shadow: 0px 2px 4px 0px ${themeColor('lightGray20')};
    border: 1px solid ${themeColor('lightGray20')};
    min-height: 125px;
    border-radius: 2px;
`

export const InfoContainter = styled(Box)`
    position: relative;
`

export const ButtonContainter = styled.div`
    position: absolute;
    right: 0.5em;
    bottom: -1em;
`

export const DistanceContainer = styled.div`
    min-width: 120px;
    padding-left: 1em;
    border-left: 1px solid ${themeColor('lightGray60')};
`

const DistanceText = ({ distance }) => <div>
    <Icon color='gray' fontSize='large' type='car-filled' />
    <Copy as='span' padding='0 0 0 0.5em' color='gray' fontWeight='medium' fontSize='small'>
        <Distance distance={distance} />
    </Copy>
</div>

DistanceText.propTypes = {
    distance: PropTypes.number.isRequired,
}

export { DistanceText }
